import './Header.scss'
import React, { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'

import mixpanel from '../../utils/mixpanel'
import { useAppDispatch } from '../../hooks/useReduxToolkit'
import { logOutUser } from '../../core/store/user/userSlice'
import { ReactComponent as Logo } from '../../icons/logo1.svg'
import { ReactComponent as BarsSolid } from '../../icons/bars-solid.svg'

const LINKS = [
  {
    label: 'Settings',
    href: '/settings'
  }
]

interface Props {
  logoVisible?: boolean
}

export default function Header ({
  logoVisible = true
}: Props): React.ReactElement {
  const dispatch = useAppDispatch()

  const [menuOpened, setMenuOpened] = useState<boolean>(false)

  const handleLogout = (e: any): void => {
    dispatch(logOutUser())
    e.stopPropagation()
    setMenuOpened(false)
    try {
      mixpanel.track('Logout')
    } catch (error) { }
    window.location.assign('/')
  }
  return (
    <div className="Header">
      <div className="header-container">
        
        {/* Left Section (Logo) */}
        <div className="header-left">
          <Link to="/">
            <Logo className="Header__logo" />
          </Link>
        </div>

        {/* Right Section (Settings & Logout) */}
        <div className="header-right">
          {LINKS.map((l) => (
            <NavLink
              key={l.label}
              to={l.href}
              onClick={() => { setMenuOpened(false); mixpanel.track(l.label) }}
              className="fw-normal text-decoration-none link-white"
            >
              {l.label}
            </NavLink>
          ))}
          <NavLink
            onClick={handleLogout}
            to="/"
            className="fw-bold text-decoration-none link-white"
          >
            Log Out
          </NavLink>
        </div>

      </div>
    </div>
  )
}
